// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EF_h","content":"styles_content__3vH6S"};